import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import Select from 'react-select-legacy'
import './MultiSelect.scss'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'

dayjs.extend(utc)
dayjs.extend(timezone)
class SelectTimeZoneField extends Component {
  static defaultProps = {
    defaultSelectAll: false,
    meta: {},
    input: {
      onChange: () => console.error('onChange is not defined'),
      value: {},
    },
  }

  state = {
    options: [],
  }

  handleChange = (option) => {
    if (!option) return null
    return this.props.input.onChange(option.value)
  }

  componentDidMount() {
    let options = Intl.supportedValuesOf('timeZone').map((item) => ({
      label: `${dayjs().tz(item).format('Z')} ${item}`,
      value: item,
      offset: dayjs().tz(item).format('Z'),
      sorter: dayjs().tz(item).format('ZZ'),
    }))
    options.sort((a, b) => a.sorter - b.sorter)
    this.setState({ options })
  }

  render() {
    const { label, placeholder, meta, input, t } = this.props
    return (
      <div className="md-select-basic md-field">
        {label && <label>{label}</label>}
        <div className={`md-multi-select`}>
          <Select
            placeholder={placeholder || t('Zona horaria')}
            value={input.value}
            options={this.state.options}
            onChange={this.handleChange}
            removeSelected={false}
          />
        </div>
        {meta.error && meta.touched && <span className="error">{meta.error}</span>}
      </div>
    )
  }
}

export default withTranslation()(SelectTimeZoneField)
